import React from 'react';

const ProcessSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-primary mb-4">Our Process</h2>
          <p className="text-xl text-gray-600">From Quote to Completion</p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          <div className="text-center">
            <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
              ⚡
            </div>
            <h3 className="text-lg font-semibold text-primary mb-3">Instant Quote</h3>
            <p className="text-gray-600">
              Get your personalized quote in under 1 minute with our online form.
            </p>
          </div>

          <div className="text-center">
            <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
              ✓
            </div>
            <h3 className="text-lg font-semibold text-primary mb-3">Free Site Assessment</h3>
            <p className="text-gray-600">
              We visit your home to verify measurements and finalize design details.
            </p>
          </div>

          <div className="text-center">
            <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
              🔧
            </div>
            <h3 className="text-lg font-semibold text-primary mb-3">Professional Installation</h3>
            <p className="text-gray-600">
              Our certified team handles everything from permits to cleanup.
            </p>
          </div>

          <div className="text-center">
            <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
              🌟
            </div>
            <h3 className="text-lg font-semibold text-primary mb-3">Enjoy Your Space</h3>
            <p className="text-gray-600">
              Relax and enjoy your new outdoor living area with full warranty coverage.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
